<app-crm-header></app-crm-header>
<app-crm-navbar></app-crm-navbar>
<router-outlet></router-outlet>

<app-crm-footer></app-crm-footer>